import React from "react";
import { ViewModelFactory } from "./ViewModelFactory";

export const ViewModelFactoryContext = React.createContext<
  ViewModelFactory<any> | undefined
>(undefined);
